var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M43.6996 0.599976H9.79959C4.49959 0.599976 0.0996094 4.99997 0.0996094 10.3V28C0.0996094 33.3 4.49959 37.7 9.79959 37.7H43.6996C48.9996 37.7 53.3996 33.3 53.3996 28V10.3C53.2996 4.99997 48.9996 0.599976 43.6996 0.599976ZM28.1996 24.4L19.8996 29.5V19.3V9.09998L28.1996 14.2L36.4996 19.3L28.1996 24.4Z"}));
}

Youtube.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 54 38"};

module.exports = Youtube;

Youtube.default = Youtube;
